import { render, staticRenderFns } from "./alertMessage.vue?vue&type=template&id=f2e327c6&scoped=true&"
import script from "./alertMessage.vue?vue&type=script&lang=js&"
export * from "./alertMessage.vue?vue&type=script&lang=js&"
import style0 from "./alertMessage.vue?vue&type=style&index=0&id=f2e327c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e327c6",
  null
  
)

export default component.exports